import React, { FC } from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import ICategoryAttributes from '../../../../../model/ICategoryAttributes';
import IExtendedFeaturesList from '../../../../../model/IExtendedFeaturesList';
import { useCheckSelectedFeatures } from '../../../../../hooks/features/useCheckSelectedFeatures';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import serviceDisplayStyles from './ServiceDisplayStyles';
import FeatureServicePlanItemList from '../../features/featureServicePlan/featureServicePlanList/FeatureServicePlanItemList';

export interface IServiceDisplayProps {
  featuresList: IExtendedFeaturesList;
  categoryAttributes?: ICategoryAttributes;
}

const ServiceDisplay: FC<IServiceDisplayProps> = ({ featuresList, categoryAttributes }) => {
  const styles = serviceDisplayStyles();
  const { handleCheckboxChange } = useCheckSelectedFeatures();

  return (
    <Box display="flex" flexDirection="column">
      {categoryAttributes?.displaylabelofselectedoptiononcategory && (
        <>
          <Typography variant="body2" className={styles.disclaimer}>
            <Translation id="trans__configurator__customise_page_service_section__section_description" />
          </Typography>

          <Link
            variant="body2"
            target="_blank"
            href="https://www.subaru.com.au/service/plans"
            className={styles.newLink}
          >
            <Translation id="trans__configurator__customise_page_service_section__show_features_link" />
          </Link>
        </>
      )}
      <FeatureServicePlanItemList features={featuresList.features} onClick={handleCheckboxChange} />
    </Box>
  );
};

export default ServiceDisplay;
